import { Typography } from "@mui/material";

/** Canonical copy when notify/submit fails (matches agent + API failure line). */
export const UNDELIVERED_MESSAGE =
  "I wasn't able to reach your nurse. Please use your nurse call bell if you need help.";

/**
 * Shown under the orb when the agent reports it could not notify the nurse.
 * Transcript is hidden; SuccessCloseTimer owns the 5s hang-up.
 */
export function UndeliveredNotice() {
  return (
    <Typography
      aria-live="assertive"
      sx={{
        fontFamily: "var(--font-sans)",
        fontWeight: 500,
        fontSize: "22px",
        lineHeight: "32px",
        textAlign: "center",
        color: "hsla(0, 0%, 100%, 0.88)",
        maxWidth: 520,
        px: 1,
      }}
    >
      {UNDELIVERED_MESSAGE}
    </Typography>
  );
}
